module.exports = __webpack_public_path__ + "img/saxophone2.197216da.png";